
import { FirearmStorageLocationPLIEntityDecoratorBase } from './firearm-storage-location-pli.decorator.base';


export class FirearmStorageLocationPLIEntityDecorator extends FirearmStorageLocationPLIEntityDecoratorBase {
  constructor() {
    super();
  }
}



